import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render() {
        return (
            <zodiac-sign-picker>
                <row>
                    <column class='is-6 is-12-mobile'>
                        {this.renderTitle()}
                    </column>
                    <column class='is-6 is-12-mobile'>
                        {this.renderViewAllLink()}
                        {this.renderGeneralLink()}
                    </column>
                </row>
                {this.renderTiles()}
                <row>
                    <column class='is-12'>
                        {this.renderFooterLink()}
                    </column>
                </row>
            </zodiac-sign-picker>
        );
    }

    renderTitle = () => {
        if (this.props.title) {
            return (
                <h3>{this.props.title}</h3>
            );
        }

        return (
            <p>Choose A Sign:</p>
        );
    }

    renderViewAllLink = () => {
        if (this.props.view_all_link) {
            return (
                <a href={`${this.props.base_url}/view-all`} class='header'>View All Horoscopes</a>
            );
        }

        return null;
    }

    renderGeneralLink = () => {
        if (this.props.general_link) {
            return (
                <a href={`${this.props.base_url}/general`} class='header'>General Horoscope</a>
            );
        }

        return null;
    }

    renderTiles = () => {
        if (this.props.mode == 'tiles' || this.state.isOpen) {
            const [click_action, impression_action] = this.props.logged_in
                ? ['LI Click', 'LI Impression']
                : ['LO Click', 'LO Impression'];

            this.trackEvent(impression_action, this.props.page_name);

            return (
                <div class='zodiac-signs'>
                    {this.props.signs.map(sign => {

                        return (
                            <a
                              class={`zodiac-sign ${sign.name}`}
                              href={`${this.props.base_url}/${sign.name}`}
                              onClick={() => this.trackEvent(click_action, sign.name)}
                            >
                                <p class='sign'>{sign.name}</p>
                                <p class='dates'>{sign.start} - {sign.end}</p>
                            </a>
                        );
                    })}
                </div>
            );
        }

        return null;
    }

    renderFooterLink = () => {
        if (this.props.footer_link) {
            return (
                <a href={`${this.props.base_url}/general`} class='footer'>GENERAL HOROSCOPE</a>
            );
        }

        return null;
    }

    trackEvent = (action, label) => {
        this.props.trackEvent(['Zodiac Sign Picker', action, label]);
    }
}

const mapStateToProps = (state) => ({
    signs: state.zodiac && state.zodiac.signs,
    logged_in: state.user && state.user.logged_in,
});


const mapDispatchToProps = (dispatch) => ({
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/zodiac-sign-picker.js